import { TimeLogApi, ToastStateHandler } from '../../../api';
import { SubmitTimelogDto } from '../../../commonTypes/timelog.types';
import { dispatch } from '../../../store';
import { addSubmissionIntervalOfProject } from '../../../store/slices/time-tracking.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

const useHttpSubmitTimelogs = () => {
    const { t } = useTranslation('newNotifications');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (body: SubmitTimelogDto) => {
        const { exec, abort } = timeLogApi.submitTimelog({
            body,
            onSuccess: res => {
                dispatch(addSubmissionIntervalOfProject(res.body));
                toastHandler.push('success', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionSuccess'));
            },
            onError: (error: AppError | string) => {
                if (isErrorCode(error, ErrorCodes.OVERLAPPING_INTERVALS)) {
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionOverlapingIntervals'));
                }
                if (isErrorCode(error, ErrorCodes.NO_TIME_LOGS_TO_SUBMIT)) {
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionNoTimeLogsInInterval'));
                }
                if (isErrorCode(error, ErrorCodes.UNFINISHED_TIME_LOGS)) {
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionUnfinishedTimelogs'));
                }
                // Use backend userMessage for unknown errors
                const message = getUserMessage(error);
                toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), message);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpSubmitTimelogs;
